import React, { Component } from 'react';
import {  Route, Link, withRouter, Switch } from 'react-router-dom';
import InfiniteScroll from "react-infinite-scroll-component";

import Modal from './Modal';
import HomepageAd from './HomepageAd'

class Thumbnail extends Component {
  state = {
    showModal: false,
    activeModalData: {
      title: "",
      subTitle: "",
      seoUrl: "",
      postId: undefined,
      postBody: [],
      label: [],
      autor: [],
      autorPic: []
    },
    filteredData: [],
    productionPathName: '/2020/08/the-whole-truth-staging/',
    activeIndex: undefined,
    disabledNewButton: false,
    disabledOldButton: false,
    displayedPostArr:[],
  };


  componentDidUpdate(prevProps,prevState) {
    if (prevProps.filteredData !== this.props.filteredData){
      var data = this.props.filteredData
      this.setState({ filteredData: data, displayedPostArr: data.slice(0,6)}, () => {
          let host = window.location.hostname,
          productionURL = host.indexOf('stuff.co.nz') >= 0,
          regexMatch,
          postId,
          matchingPostIndex;
          
          if(productionURL){
          // check data array 
          // check url is larger than initial url 
          // console.log('in produrl?', productionURL)
          
          // console.log('window.location.hash.length: ',window.location.hash.length,'this.state.productionPathName.length',this.state.productionPathName )
          if(this.state.filteredData.length > 0 && window.location.hash.length > 2 ){
            // grab what would theoretically be the postId
            regexMatch = window.location.hash.match(/\/(\d+)\//);
            // if there is a regex match
            // console.log('post id is:', regexMatch)
            if (regexMatch) {
            postId = parseInt(regexMatch[1]);
            // find the index of the post object in the data array that matches the postIds
            matchingPostIndex = data.findIndex(obj => {
              return obj.postId === postId
            })
            // console.log('is this running?')
            this.updateActiveIndex(matchingPostIndex, "urlTrigger");
            }
          }
          }else{
            if (this.state.filteredData.length > 0 && window.location.hash.length > 1) {
              // grab what would theoretically be the postId
              regexMatch = window.location.hash.match(/\/(\d+)\//);
              // if there is a regex match
              if (regexMatch) {
                postId = parseInt(regexMatch[1]);
                // find the index of the post object in the data array that matches the postIds
                matchingPostIndex = data.findIndex(obj => {
                  return obj.postId === postId
                })
                this.updateActiveIndex(matchingPostIndex, "urlTrigger");
              }
            }
          }
      });
    }
  }

  updateActiveIndex = (currentIndex, clickedButtonType) => {
    if (clickedButtonType === "openModal") {
      this.setState({ activeIndex: currentIndex }, () => {
        this.checkPostNavButtons();
        this.updateActiveModalData(this.state.activeIndex);
        this.updateURLPath(this.state.activeIndex);
      }) 
    } else if (clickedButtonType === "clickNewPost") {
      // as long as the new index is not below 0
      if (currentIndex > 0) {
        this.setState({ activeIndex: currentIndex - 1}, () => {
          this.checkPostNavButtons();
          this.updateActiveModalData(this.state.activeIndex);
          this.updateURLPath(this.state.activeIndex);
        })
      }
    } else if (clickedButtonType === "clickOldPost") {
      // as long as the new index is not greater than highest index available
      if (currentIndex <= this.state.filteredData.length - 1) {
        this.setState({ activeIndex: currentIndex + 1}, () => {
          
          this.checkPostNavButtons();
          this.updateActiveModalData(this.state.activeIndex);
          this.updateURLPath(this.state.activeIndex);
        })
      }
    } else if (clickedButtonType === "urlTrigger") {
      // console.log('prod updater url triggered?')
      this.setState({ 
        activeIndex: currentIndex,
        showModal: true
      }, () => {
        this.checkPostNavButtons();
        this.updateActiveModalData(this.state.activeIndex);
        this.updateURLPath(this.state.activeIndex);
        document.body.classList.add('overflowforbody')
      });
    } 
  }

  checkPostNavButtons = () => {
    var arrayLength = this.state.filteredData.length;
    var lastIndexInArray = arrayLength - 1;

    if (this.state.activeIndex === 0) {
      if(arrayLength <=1){
        this.setState({
          disabledNewButton: true,
          disabledOldButton: true
        })
      }else{
        this.setState({
          disabledNewButton: true,
          disabledOldButton: false
        })
      }

    } else if (this.state.activeIndex === lastIndexInArray) {
      this.setState({
        disabledNewButton: false,
        disabledOldButton: true
      })
    } else {
      this.setState({
        disabledNewButton: false,
        disabledOldButton: false
      })
    }
  }

  updateActiveModalData = (newIndex) => {
    this.setState({
      activeModalData: {
        title: this.state.filteredData[newIndex].title,
        subTitle: this.state.filteredData[newIndex].subTitle,
        seoUrl: this.state.filteredData[newIndex].seoUrl,
        id: newIndex,
        postBody: this.state.filteredData[newIndex].postBody,
        label: this.state.filteredData[newIndex].label,
        autor: this.state.filteredData[newIndex].autor,
        autorPic: this.state.filteredData[newIndex].autorPic
      }
    })  
  }

  openModal = (index) => {
    this.updateActiveIndex(index, "openModal");
    this.setState({showModal: true });
    document.body.classList.add('overflowforbody')
  };

  hideModal = (index) => {
    this.updateActiveIndex(index, "closeModal");
    this.setState({ 
      showModal: false
    }, (e)=>{
      this.backURLPath()
    }
    );
    document.body.classList.remove('overflowforbody');
    // google ad slot distroy
    var slotArr = window.googletag.pubads().getSlots();
    window.googletag.destroySlots([slotArr[slotArr.length - 1]]); 
  };

  backURLPath = () => {
    let host = window.location.hostname,
    productionURL = host.indexOf('stuff.co.nz') >= 0;
    if(productionURL){
      // this.props.history.push('/2020/08/the-whole-truth-staging/')
      this.props.history.push('/')
    }else{
      this.props.history.push('/')
    }
  };

  updateURLPath = (pathIndex) => {
    let host = window.location.hostname,
    productionURL = host.indexOf('stuff.co.nz') >= 0;
    if(productionURL){
      // console.log('prod url',this.state.filteredData[pathIndex].postId)
      this.props.history.push(`/${this.state.filteredData[pathIndex].postId}/${this.state.filteredData[pathIndex].seoUrl}`)
    }else{
      this.props.history.push(`/${this.state.filteredData[pathIndex].postId}/${this.state.filteredData[pathIndex].seoUrl}`)
    }
  };


  newPostButton = () => {
    this.updateActiveIndex(this.state.activeIndex, 'clickNewPost');
    document.querySelector('.modalwrapper--modalbox').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
    // google ad slot distroy
    // google ad slot distroy
    var slotArr = window.googletag.pubads().getSlots();
    // console.log('newerpost', slotArr)
    window.googletag.destroySlots([slotArr[slotArr.length - 1]]); 
    // var slot = window.googletag.pubads().display( '/6674/stuff.wholetruth',[300,250], `div-gpt-ad-8564960-${this.state.activeModalData.id}`);
    // // console.log(this.state.activeModalData.id)
    // window.googletag.destroySlots([slot]);
    
  };

  oldPostButton = () => {
    this.updateActiveIndex(this.state.activeIndex, 'clickOldPost');
    document.querySelector('.modalwrapper--modalbox').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
    // google ad slot distroy
    var slotArr = window.googletag.pubads().getSlots();
    // console.log('olderpost', slotArr)
    window.googletag.destroySlots([slotArr[slotArr.length - 1]]); 
    // var slot = window.googletag.pubads().display( '/6674/stuff.wholetruth',[300,250], `div-gpt-ad-8564960-${this.state.activeModalData.id}`);
    // // console.log(this.state.activeModalData.id)
    // window.googletag.destroySlots([slot]);
  };

  fetchMoreData = () => {
    var data = this.state.filteredData;
    var shownumbr = this.state.filteredData.length - 1;
    var currentPostLast = this.state.displayedPostArr.length,
    joinedArr;
          for (var i = 0; i < shownumbr; i++) {
            if (currentPostLast  + i < data.length) {
                // this.state.displayedPostArr.push(data[currentPostLast + i])
                joinedArr = this.state.displayedPostArr.concat(data[currentPostLast + i])
                this.setState({
                  displayedPostArr : joinedArr 
                },()=>{
                  // console.log(this.state.displayedPostArr.length)
                })
            }
        }

  };

  render() {
    const { activeModalData,filteredData, disabledNewButton,disabledOldButton, displayedPostArr} = this.state;
    // console.log('current post array',displayedPostArr)
    return (
      <React.Fragment>
       <InfiniteScroll
            dataLength={filteredData.length}
            next={this.fetchMoreData}
            hasMore={true}
            // loader={<h4>Loading...</h4>}
          > 
        <div className="thumbnail-container">{displayedPostArr.map((item, index)=>(
            <div className={`thumbnail-container--eachbox thumbnail-container--eachbox--${item.label.replace(/\s+/g,"")}`} key={index} >
            <div className="thumbnail-container--eachbox---descriptionbox">
              <span className={`label-index label-index--${item.label.replace(/\s+/g,"")}`}>{item.label}</span>
              <span className="thumbnail-container--eachbox---descriptionbox--title">{item.title}</span>
              <span className="thumbnail-container--eachbox---descriptionbox--subheading">{item.subTitle}</span>
            </div>
            <Link
            className="thumbnail-container--eachbox---link"
        key={item.postId}
        to={`/${item.postId}/${item.seoUrl}`}
        replace
        ><span onClick={() => this.openModal(index)}  className="thumbnail-container--eachbox--button">Read More</span></Link>
        </div>
        ))}

           

        </div>
        <HomepageAd />
         </InfiniteScroll> 
         <Switch>
        <Route
            path="/:postId/:seoUrl"
            render={()=>{
              return (
              <Modal
                show={this.state.showModal}
                onHide={this.hideModal}
                newClick={this.newPostButton} 
                oldClick={this.oldPostButton}
                disabledNewButton={disabledNewButton}
                disabledOldButton={disabledOldButton}
                activeModalData={activeModalData}
                />
              )
            }} />
            </Switch>
        </React.Fragment>
    );
  }
}

export default withRouter(Thumbnail);
